var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinaryCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.13,
    y1: 41.25,
    x2: 38.13,
    y2: 70.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.13,
    y1: 135.57,
    x2: 38.13,
    y2: 165.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 123.81,
    y1: 106.77,
    x2: 123.81,
    y2: 150.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.69,
    y1: 41.25,
    x2: 90.69,
    y2: 70.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.25,
    y1: 41.25,
    x2: 143.25,
    y2: 70.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 123.09,
    cy: 126.93,
    r: 40.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.65,149.25l24.48,25.2s9.36,7.2,2.16,15.84c0,0-5.76,5.76-13.68-2.16l-24.48-25.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.69,
    y: 41.97,
    width: 19.44,
    height: 28.08,
    rx: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.25,
    y: 41.97,
    width: 19.44,
    height: 28.08,
    rx: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 159.81,
    y: 41.97,
    width: 19.44,
    height: 28.08,
    rx: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 159.81,
    y: 89.49,
    width: 19.44,
    height: 28.08,
    rx: 9.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,117.57h-.63a9.44,9.44,0,0,1-9.41-9.4V98.89a9.44,9.44,0,0,1,9.41-9.4H82a9.43,9.43,0,0,1,9.4,9.4v2.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.69,
    y: 89.49,
    width: 19.44,
    height: 28.08,
    rx: 9.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,163.65h-.64c3.38,0,6.85-3.51,6.85-8.68v-9.28a9.43,9.43,0,0,0-9.4-9.4h-.63a9.44,9.44,0,0,0-9.41,9.4v5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.69,
    y: 136.29,
    width: 19.44,
    height: 28.08,
    rx: 9.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaryCode);
export default __webpack_public_path__ + "static/media/BINARY_CODE.1620556a28e6c46efc5b888ef8a4a4db.svg";
export { ForwardRef as ReactComponent };